import React from "react";

export const imgPath = (path) => {
    return process.env.REACT_APP_APIURL + "/img/" + path
}

export const exportCsvPath = (path) => {
    return process.env.REACT_APP_APIURL + "/" + path + "/export/csv"
}